import '@babel/polyfill'
import Vue from 'vue';
import '@/plugins/vuetify'
import * as firebase from 'firebase';
import router from '@/router/router.js';
import { store } from '@/store/store.js';
import App from '@/App.vue';

import AlertComp from '@/components/Alert.vue';

Vue.config.productionTip = false;

Vue.component('app-alert', AlertComp); //Adding a global component


new Vue({
  router,
  store,
  render: h => h(App),
  created () {
    firebase.initializeApp({
      apiKey: 'AIzaSyBNMHkLCiKazl9oqpJEEKyh3ECT6aVDn7E',
      authDomain: 'vuefbtest.firebaseapp.com',
      databaseURL: 'https://vuefbtest.firebaseio.com',
      projectId: 'vuefbtest',
      storageBucket: 'vuefbtest.appspot.com',
    })

    //this.$store.dispatch('loadRecords')
  }
}).$mount('#app');
